import { createI18n } from 'vue-i18n';

import { account } from '@/_redesign/modules/Account/locale';
import { card } from '@/_redesign/modules/Card/locale';
import { entrance } from '@/_redesign/modules/Entrance/locale';
import { onboarding } from '@/_redesign/modules/Onboarding/locale';
import { profile } from '@/_redesign/modules/Profile/locale';
import otp from '@/_redesign/modules/shared/Otp/i18n.otp.json';
import transaction from '@/_redesign/modules/shared/Transactions/i18n.transaction.json';
import { transfers } from '@/_redesign/modules/Transfers/locale';

import en from './en.json';

export const messages = {
  en: {
    ...en,
    card: card.en,
    transaction, // TODO: 537897 Add index file with en inside
    otp, // TODO: 537897 Add index file with en inside,
    account: account.en,
    entrance: entrance.en,
    profile: profile.en,
    onboarding: onboarding.en,
    transfers: transfers.en,
  },
};

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  globalInjection: true,
  messages,
  silentTranslationWarn: true,
  allowComposition: true,
  missingWarn: false,
});

export const translate = (...keys: string[]) => {
  if (keys.length === 0) return '';
  for (let i = 0; i < keys.length - 1; i += 1) {
    const t = i18n.global.t(keys[i]);
    if (t !== keys[i]) return t;
  }
  return i18n.global.t(keys.at(-1) ?? '');
};
